(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvHtmlEditor', drvHtmlEditor);

    drvHtmlEditor.$inject = [];
    drvHtmlEditorCtrl.$inject = ['DialogService', 'FieldSelectorService'];
    
    /**
     * Html Editor which contains ChilliDocs specific functionality such as adding merge fields.
     *
     * # Scope Properties
     * {string} value - The value which is to be bound to the html editor.
     * {string} label - The label/name to be shown. Optional.
     * {int} minHeight - Minimum height of the html editor. Optional.
     * {int} height - Height of the html editor. Used if auto resize is not enabled. Optional.
     * {bool} showAddFieldButton - Override to show the Insert Field(s) button, even if the addFieldEntityTemplate has not yet been supplied. Optional.
     * {object} addFieldEntityTemplate - Entity template to be used with the Insert Field(s) functionality. If not supplied the Insert Field(s) button will not be shown. Optional.
     * @param {bool} includeOrganisation - Optional, default is false. True if fields for the 'Organisation'
     *   entity template are to be included in the Insert Field dialog
     * @param {bool} includeCurrentUser - Optional, default is false. True if fields for the current user
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeDocumentTemplate - Optional, default is false. True if fields for the 'Document Template'
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeFileDetails - Optional, default is false. True if fields for the 'File'
     *   are to be included in the Insert Field dialog.
     * @param {bool} excludeFileDetailsName - Optional, default is false. True if 'Name' field for the 'File'
     *   is to be excluded in the Insert Field dialog.
     * @param {bool} includeEntitySystem - Optional, default is false. True if system fields for the entity
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeEntitySystemForPreview - Optional, default is false. True if system fields for the entity preview
     *   are to be included in the Insert Field dialog.
     * {bool} readOnly - Used to set the html editor into read only mode. Optional.
     * {bool} hideToolbar - Used to hide the html editors toolbar. Optional.
     * {bool} autoResize - Should the html editor auto resize to fit content. Optional.
     * {bool} ngRequired - Value must be entered. Optional.
     */
    function drvHtmlEditor() {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {},
            controller: drvHtmlEditorCtrl,
            controllerAs: 'vm',
            bindToController: {
                value: '=',
                label: '<?',
                minHeight: '<?',
                height: '<?',
                showAddFieldButton: '<?',
                includeOrganisation: '<?',
                includeCurrentUser: '<?',
                includeDocumentTemplate: '<?',
                includeFileDetails: '<?',
                excludeFileDetailsName: '<?',
                includeEntitySystem: '<?',
                includeEntitySystemForPreview: '<?',
                addFieldEntityTemplate: '<?',
                readOnly: '<?',
                hideToolbar: '<?',
                autoResize: '<?',
                ngRequired: '<?'
            },
            template:
                '<div ng-form="html">' +
                '<p class="material-label-fake" ng-class="{ mandatory : vm.ngRequired, invalid : vm.invalid && (html[vm.label].$touched || (vm.value !== undefined && vm.value !== null && vm.value !== \'\')) }" style="margin-bottom: 0px !important;">{{vm.label}}</p>' +
                '<textarea name="{{vm.label}}" ui-tinymce="vm.tinymceBodyEdit" ng-model="vm.value" ng-required="vm.ngRequired" flex="100" ng-if="!vm.readOnly"></textarea>' +
                '<textarea name="{{vm.label}}" ui-tinymce="vm.tinymceBodyView" ng-model="vm.value" ng-required="vm.ngRequired" flex="100" ng-if="vm.readOnly"></textarea>' +
                '</div>'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    function drvHtmlEditorCtrl(DialogService, FieldSelectorService) {
        /* jshint validthis:true */
        var vm = this;
        Object.defineProperty(vm, 'invalid', {
            get: function () {
                return (vm.ngRequired && (_.isNil(vm.value) || vm.value === ''));
            }
        });

        activate();

        function activate() {
            var plugins = 'textcolor colorpicker noneditable code link paste lists ';

            if (!_.isNil(vm.autoResize) && vm.autoResize) {
                plugins += ' autoresize';
            }

            vm.tinymceBodyEdit = {
                force_br_newlines: false,
                force_p_newlines: true,
                forced_root_block: false,
                height: vm.height || 250,
                inline: false,
                convert_fonts_to_spans: true,
                fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
                font_formats: 'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Calibri=calibri;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats',
                plugins: [
                        plugins
                ],
                noneditable_noneditable_class: "mceNonEditable",
                toolbar: ' insertfile undo redo | bold italic fontsizeselect fontselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | link unlink image | insertfield ',
                statusbar: false,
                menubar: false,
                readonly: false,
                branding: false,
                setup: tinyMceSetup,
                autoresize_bottom_margin: 0,
                autoresize_min_height: vm.minHeight || 80,
                paste_data_images: true
            };

            vm.tinymceBodyView = {
                force_br_newlines: false,
                force_p_newlines: true,
                forced_root_block: false,
                height: vm.height || 250,
                inline: false,
                convert_fonts_to_spans: true,
                fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
                font_formats: 'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Calibri=calibri;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats',
                plugins: [
                        plugins
                ],
                noneditable_noneditable_class: "mceNonEditable",
                toolbar: ' insertfile undo redo | bold italic fontsizeselect fontselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | link unlink image | insertfield ',
                statusbar: false,
                menubar: false,
                readonly: true,
                branding: false,
                setup: tinyMceSetup,
                autoresize_bottom_margin: 0,
                autoresize_min_height: vm.minHeight || 80,
                paste_data_images: true
            };

            function tinyMceSetup(editor) {
                if (vm.hideToolbar) {
                    editor.settings.toolbar = false;
                }

                if (vm.showAddFieldButton || !_.isNil(vm.addFieldEntityTemplate)) {
                    editor.addButton('insertfield', {
                        text: 'Insert Field(s)',
                        onclick: function () {
                            insertMergeField(editor);
                        },
                        classes: 'add-field-button'
                    });
                }

                editor.on('init', function () {
                    this.getDoc().body.style.fontSize = '11pt';
                    this.getDoc().body.style.fontFamily = 'Calibri,sans-serif';
                });
            }
        }

        /*
         * Opens the field selector dialog and adds the field reference to the text area of the specified TinyMCE editor.
         *
         * @param {object} editor - TinyMCE editor object which will have a merge field inserted.
         */
        function insertMergeField(editor) {
            if (!_.isNil(vm.addFieldEntityTemplate)) {
                FieldSelectorService.displayDialogForEntityTemplate(vm.addFieldEntityTemplate, {
                    multiSelect: true,
                    includeOrganisation: vm.includeOrganisation,
                    includeCurrentUser: vm.includeCurrentUser,
                    includeDocumentTemplate: vm.includeDocumentTemplate,
                    includeFileDetails: vm.includeFileDetails,
                    excludeFileDetailsName: vm.excludeFileDetailsName,
                    includeEntitySystem: vm.includeEntitySystem,
                    includeEntitySystemForPreview: vm.includeEntitySystemForPreview
                }).then(function (data) {
                    angular.forEach(data, function (fieldReference) {
                        editor.execCommand('mceInsertContent', false, fieldReference);
                    });
                });
            } else {
                DialogService.alert('Entity Template must be selected before Insert Field can be used');
            }
        }
    }
})();